import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {CarePlanServiceGroupType} from "../care-plan-service-group-type.model";

export class CarePlanServiceGroupTypeDgSearchResults extends GenericDgSearchResults {
  public results: CarePlanServiceGroupType[];

  constructor(total: number, results: CarePlanServiceGroupType[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

